import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router'
import router from './config/router'
import ElementUI from 'element-ui';
import method from '@/config/api'
import request from '@/config/index'
import websocket from '@/commit/websocket'
import 'element-ui/lib/theme-chalk/index.css';
import './style.css'
import './mixin.css'

// import '@/config/lib-flexible'

Vue.use(Router)
Vue.use(ElementUI);

Vue.config.productionTip = false;
Vue.prototype.$method = method;
Vue.prototype.$postRequest = request.post;
Vue.prototype.$getRequest = request.get;
Vue.prototype.$imgurl = request.baseURL;
Vue.prototype.websocket = websocket;
Vue.prototype.emojiMaplist = [
'😉', '😃', '😅', '🤡', '😊', '🤑', '😌', '😍', '👍', '👌', '😷', '😇', '😛', '😂', '😄', '😁',
'🤣', '🙂','🌘', '🌗', '🌖', '🌕', '🌔', '🌓', '🌒', '🌑', '🌚', '🥰', '😘', '🙃', '😆', '😀', 
'😗', '😝','🤓', '😏', '😒', '😎', '😙', '😚', '🤪', '😞', '😔', '🤩', '🤨', '😋', '🧐', '🥳', 
'😟', '😏','😕', '😫', '😤', '😒', '🙁', '😩', '😠', '😡', '🥺', '😞', '😔', '😣', '😢', '🤬', 
'🤯', '😭','😖', '😟', '😳', '🥵', '🥶', '😶‍️', '😱', '😨', '😰', '😥', '😓', '🤗', '🤔', '🤭', 
'🤫', '🤥', '😶', '😐', '😑', '😬', '🙄', '😯', '😦', '😧', '😮', '😲', '🥱', '😴', '🤤', '😪', 
'😮', '‍😵','‍🤐', '🥴', '🤢', '🤮', '🤧', '🤒', '🤕', '🤠', '⭐', '️🌟', '✨', '💫', '💨', '🤲',
'👐', '🙌', '👏', '🤝', '👎', '👊', '✊', '🤛', '🤜', '🤞', '🤟', '🤘', '🤏', '👈', '👉', '👆',
'👇', '️✋', '🤚', '🖐', '️🖖', '👋', '🤙', '💪', '🙏'
], // 表情

document.title = ''

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
// 发布者订阅 公共bus
export const Bus = new Vue();

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
